export enum AuthMethod {
  // On-premises: EWS goes through Office, so no sign-in is needed.
  NONE = 'none',
  // NAA without prompting the user.
  NAA_SILENT = 'naaSilent',
  // NAA that prompts the user if needed.
  NAA_INTERACTIVE = 'naaInteractive',
  // Office SSO with an OBO exchange, used when NAA is not supported.
  SSO = 'sso',
  // Dialog API with MSAL behind the login button, used when no automatic method worked.
  DIALOG = 'dialog',
}

// QA override to force an auth method, set from the debug overlay (Ctrl+Shift+D).
// Only honored on development and staging builds.
const AUTH_METHOD_OVERRIDE_KEY = 'debug.authMethod';

export const getIsAuthMethodOverrideAllowed = () =>
  process.env.TARGET_ENV === 'development' || process.env.TARGET_ENV === 'staging';

export const getAuthMethodOverride = () =>
  getIsAuthMethodOverrideAllowed()
    ? (localStorage.getItem(AUTH_METHOD_OVERRIDE_KEY) as AuthMethod | null)
    : null;

export const setAuthMethodOverride = (method: string) => {
  if (method) {
    localStorage.setItem(AUTH_METHOD_OVERRIDE_KEY, method);
  } else {
    localStorage.removeItem(AUTH_METHOD_OVERRIDE_KEY);
  }

  // Tokens only live in memory, so a reload signs out and starts over with the new method.
  window.location.reload();
};
